import { makeStyles } from '@mui/styles';

import Button from '@classify/react-core-components/Button';

import PeopleItem from '../PeopleItem';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    marginTop: spacing(2),
  },

  action: {
    textAlign: 'right',
    padding: spacing(1, 0),
    flexGrow: 1,
  },

  [breakpoints.up('sm')]: {
    root: {
      display: 'flex',
    },
  },
}));

export default function SelectedPeople({ people, translations, onConfirm = () => {} }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <PeopleItem
          userId={people.id}
          userName={people.displayName}
          subHeading={people.subHeading}
          avatarUrl={people.avatar}
        />
      </div>
      <div className={classes.action}>
        <Button onClick={() => onConfirm(people)}>{translations.confirmSelection}</Button>
      </div>
    </div>
  );
}
